Vue.component('users', {
    props: ['client-id'],

    data () {
        return {
            loading: false,

            deleting: false,

            users: [],

            availableUsers: [],

            groups: [],

            filters: {
                search: ''
            },

            createForm: $.extend(true, new Form({
                data: {
                    user: '',
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: ''
                }
            }), {}),

            userId: '',

            loadingEmails: false,

            emails: [],

            defaulting: false,

            testing: false
        };
    },

    mounted () {
        this.getUsers();
    },

    methods: {
        getUsers () {
            this.loading = true;

            axios.get('/api/client-users', {
                params: {
                    client_id: this.clientId,
                    ...this.filters
                }
            }).then(response => {
                this.loading = false;
                this.users = response.data.users;
                this.availableUsers = response.data.available_users;
                this.groups = response.data.groups;
            });
        },

        remove (id) {
            $('#user-remove').modal('show');

            this.deleteId = id;
        },

        doRemove () {
            this.deleting = true;

            axios.post('/api/client-users/delete', {}, {
                params: {
                    client_id: this.clientId,
                    user_id: this.deleteId
                }
            }).then( (response) => {
                if (response.status === 200) {
                    $('#user-remove').modal('hide');

                    this.deleting = false;

                    this.getUsers();
                }
            });
        },

        add () {
            Http.post('/api/client-users/add', this.createForm, {
                params: {
                    client_id: this.clientId
                }
            }).then((response) => {
                // Reset, no need to display
                this.createForm.resetForm();
                this.createForm.resetAlert();

                // Reload the main list
                this.getUsers();

                // Open the DNS information
                $('#add-user').modal('hide');
            });
        },

        getEmail (id) {
            this.userId = id;

            $('#emails').modal('show');
        }
    }
});